import baseApi from './base_api.js'

export function allMemo(options) {
  return baseApi.post('/allMemo', { ...options })
}

export function addMemo(options) {
  return baseApi.post('/addMemo', { ...options })
}

export function deleteMemo(options) {
  return baseApi.post('/deleteMemo', { ...options })
}

export function toggleMemoStatus(options) {
  return baseApi.post('/toggleMemoStatus', { ...options })
}

export function memoDeadlineByDate(options) {
  return baseApi.post('/memoDeadlineByDate', { ...options })
}

export function memoDeadlineRange(options) {
  return baseApi.post('/memoDeadlineRange', { ...options })
}
